import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { STRING } from 'resources'

import generalSelectors from 'models/General/selectors'

import RegionText from './styles'

export const AppInformationText = ({ region = null }) => (
  <RegionText>{STRING.appGeneralInfo.appInfo(region)}</RegionText>
)

AppInformationText.propTypes = {
  region: PropTypes.string,
}

const mapStateToProps = (state) => ({
  region: generalSelectors.getRegion(state),
})

export default connect(mapStateToProps)(AppInformationText)
